module.exports = __webpack_public_path__ + "static/img/ECOCA.4ad947fe.png";